import React, { useEffect, useRef } from 'react'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'
import { nothing } from '$func/utils'
import { isPhoneOrTablet } from '$func/environmentInfo'
import {
  SWIPABLE_ZOOM_THRESHOLD,
  SWIPE_THRESHOLD,
} from '$comp/modals/media-viewer/media-viewer.constant'

export function ViewerTransformWrapper({
  onPrev,
  onNext,
  children,
}: {
  onPrev?: () => void
  onNext?: () => void
  children: JSX.Element
}) {
  const x = useRef(0)
  const offset = useRef(0)
  const onPervRef = useRef(nothing)
  const onNextRef = useRef(nothing)
  const scale = useRef(0)

  useEffect(() => {
    onPervRef.current = onPrev
    onNextRef.current = onNext
  }, [onNext, onPrev])

  const onPanningEnd = () => {
    if (scale.current > SWIPABLE_ZOOM_THRESHOLD) return
    if (
      onPervRef.current &&
      offset.current &&
      offset.current - x.current > SWIPE_THRESHOLD
    ) {
      onPervRef.current()
    }
    if (
      onNextRef.current &&
      offset.current &&
      offset.current - x.current < -SWIPE_THRESHOLD
    ) {
      onNextRef.current()
    }
  }

  return (
    <TransformWrapper
      doubleClick={{ disabled: true }}
      onPanningStart={(r, e) => {
        if (isPhoneOrTablet) {
          if ((e as TouchEvent).changedTouches?.[0]?.clientX) {
            x.current = (e as TouchEvent).changedTouches[0].clientX
          }
        } else if ((e as MouseEvent).clientX) {
          x.current = (e as MouseEvent).clientX
        }
        offset.current = null
        e.stopPropagation()
      }}
      onPanning={(r, e) => {
        if (isPhoneOrTablet) {
          if ((e as TouchEvent).changedTouches?.[0]?.clientX) {
            offset.current = (e as TouchEvent).changedTouches[0].clientX
          }
        } else if ((e as MouseEvent).clientX) {
          offset.current = (e as MouseEvent).clientX
        }
        e.stopPropagation()
      }}
      onPanningStop={(r, e) => {
        onPanningEnd()
        e.stopPropagation()
      }}
      onZoom={r => {
        scale.current = r.state.scale
      }}
    >
      <TransformComponent>{children}</TransformComponent>
    </TransformWrapper>
  )
}

ViewerTransformWrapper.defaultProps = {
  onPrev: null,
  onNext: null,
}
